import React from 'react';
import ReactPageNav from './ReactPageNav';

import styles from './PageNav.scss';

// const propTypes = {
//   page: React.PropTypes.number,
//   total: React.PropTypes.number,
//   perPage: React.PropTypes.number,
//   text: React.PropTypes.string,
//   handleChangePage: React.PropTypes.func,
// };

const defaultProps = {
};


export default class PageNav extends React.Component {
  handleClick = (e, page) => {
    e.preventDefault();
    if (typeof this.props.handleChangePage === 'function') {
      this.props.handleChangePage(page);
    }
  }

  renderNav = (units) => {
    const items = units.map((item, i) => (
      <a
        className={styles[item.class]}
        href=""
        onClick={e => this.handleClick(e, item.page)}
        key={i}
      >
        <span>{item.html}</span>
      </a>
    ));
    return (
      <div className={styles.nav}>
        {items}
      </div>
    );
  }


  render() {
    const { page, total, perPage, text } = this.props;
    ReactPageNav.default.prevHtml = '<';
    ReactPageNav.default.nextHtml = '>';

    return (
      <div className={styles.root}>
        <div className={styles.text}>{text}</div>
        <ReactPageNav
          page={page}
          total={total}
          pageSize={perPage}
          maxLink={7}
          render={this.renderNav}
        />
      </div>
    );
  }
}

// PageNav.propTypes = propTypes;
PageNav.defaultProps = defaultProps;
